import React from 'react';
import styles from './Date.module.scss';
import RawHTML from '@components/RawHTML';
import classNames from 'classnames';

export default function Date({ value, className }) {
  value = value?.trim();

  if (!value) {
    return null;
  }

  value = value
    .replace(/(\d) *- *(\d)/g, '$1*-*$2')
    .split('*-*')
    .join(`<span class="${styles.dash}">-</span>`);

  return !value ? null : (
    <div className={classNames(styles.wrapper, className)}>
      <RawHTML>{value}</RawHTML>
    </div>
  );
}
